import React from 'react';
import {observer} from 'mobx-react';
import {PCS_CSS} from '../../../rendering/render.def';
import {PropsWithChildren} from 'react';

type Props = PropsWithChildren<{
    css: PCS_CSS;
    isInnerAccent: boolean;
}>;

export const PrimaryMatWrapper: React.FC<Props> = observer(({css, isInnerAccent, children}: Props) => {
    return isInnerAccent ? (
        <div
            id="ep_smat"
            style={{
                backgroundColor: css.doc1_smat_backgroundColor,
                left: css.ep_pmat_left,
                top: css.ep_pmat_top,
                width: css.ep_smat_width,
                height: css.ep_smat_height,
                transform: 'translate(-50%, -50%)',
            }}
        >
            {children}
        </div>
    ) : (
        <>{children}</>
    );
});
